import { defineStore } from 'pinia';
import { setLocalStorage, getFromLocalStorage } from '@/utils/storage';
import { i18n } from '@/langs/i18n';
import { type settingType } from './types';

export const useSettingStore = defineStore('setting', {
  state: (): settingType => ({
    lang: (i18n.global.locale as any).value,
    isFirstOpen: String(getFromLocalStorage('isFirstOpen')) !== 'false',
    hostUrl: getFromLocalStorage('BaseUrlKey') || '',
    sysName: getFromLocalStorage('sysName') || '',
  }),
  actions: {
    setLang(lang: string) {
      this.lang = lang;
      (i18n.global.locale as any).value = lang;
      setLocalStorage('lang', lang);
    },
    setIsFirstOpen(isFirstOpen: boolean) {
      this.isFirstOpen = isFirstOpen;
      setLocalStorage('isFirstOpen', isFirstOpen);
    },
    setHostUrl(hostUrl) {
      this.hostUrl = hostUrl;
      setLocalStorage('BaseUrlKey', hostUrl);
    },
    setSysName(sysName) {
      this.sysName = sysName;
      setLocalStorage('sysName', sysName);
    },
  },
});
